var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.153 27.61a13.996 13.996 0 0 1-6.073-9.943c.2.46.43.947.69 1.436.7 1.315 1.628 2.679 2.76 3.566 2.803 2.196 5.326 1.818 6.8 1.597l.006-.001c.66-.1 1.441-.505 2.125-.933a20.463 20.463 0 0 0 1.747-1.245l-.018-.022A8.377 8.377 0 0 0 18.776 16c0-2.233-.87-4.262-2.291-5.767.714-.698 1.95-1.659 3.508-2.08 2.519-.68 5.37.472 7.497 2.386.812.729 1.39 1.775 1.781 2.812.392 1.033.584 2.025.642 2.61l.062-.005V16a13.978 13.978 0 0 1-5.41 11.057A13.934 13.934 0 0 1 15.977 30c-2.899 0-5.592-.881-7.825-2.39zm21.146-15.917a14.02 14.02 0 0 0-10.502-9.409A14.04 14.04 0 0 0 15.978 2c-.966 0-1.91.098-2.82.284C7.005 3.544 2.323 8.84 2 15.284l.043.19c.224.764.693 2.02 1.367 3.288.68 1.28 1.553 2.54 2.568 3.336 2.557 2.004 4.816 1.665 6.246 1.45h.005c.5-.075 1.17-.406 1.846-.83a18.49 18.49 0 0 0 1.38-.966A8.372 8.372 0 0 1 13.18 16c-.001-2.354.967-4.482 2.526-6.007.715-.765 2.173-2.02 4.099-2.54 2.849-.77 5.946.544 8.171 2.547.535.481.97 1.07 1.323 1.693z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/MC.f3e045d059152d04f3ff05752c42ad22.svg";
export { ForwardRef as ReactComponent };